import { Box, Tooltip } from '@mui/material';
import React from 'react';
/**
 * Renders text in a table cell. Text will not wrap. Ellipsis will be shown if text overflows.
 */
export const TextCell = ({ sx, children, textOverflowAfterLines = 1, showToolbarWhenTextOverflows = false }) => {
    const [isOverflowVisible, setIsOverflowVisible] = React.useState(false);
    const textCellRef = React.createRef();
    const columnTextOverflowAfterLines = textOverflowAfterLines > 0 ? textOverflowAfterLines : 1;
    const overflowSx = {
        textWrap: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'wrap',
        display: '-webkit-box',
        WebkitLineClamp: columnTextOverflowAfterLines,
        WebkitBoxOrient: 'vertical',
        wordBreak: 'break-all',
    };
    const checkOverflow = React.useCallback(() => {
        const textCell = textCellRef.current;
        if (!textCell) {
            return;
        }
        setIsOverflowVisible(showToolbarWhenTextOverflows && (textCell.offsetHeight < textCell.scrollHeight || textCell.offsetWidth < textCell.scrollWidth));
    }, [showToolbarWhenTextOverflows, textCellRef]);
    React.useLayoutEffect(checkOverflow);
    React.useEffect(() => {
        let resizeObserver;
        const textCell = textCellRef.current;
        if (textCell && showToolbarWhenTextOverflows) {
            resizeObserver = new ResizeObserver(() => {
                window.requestAnimationFrame(checkOverflow);
            });
            resizeObserver.observe(textCell);
        }
        return () => {
            if (resizeObserver && textCell) {
                resizeObserver.unobserve(textCell);
            }
        };
    }, [checkOverflow, showToolbarWhenTextOverflows, textCellRef]);
    const defaultTextCellComponent = (React.createElement(Box, { ref: textCellRef, component: 'div', sx: mergeSx(overflowSx, sx) }, children));
    if (isOverflowVisible) {
        return React.createElement(Tooltip, { title: children }, defaultTextCellComponent);
    }
    return defaultTextCellComponent;
};
function mergeSx(sx1, sx2) {
    if (sx2) {
        return [...(Array.isArray(sx1) ? sx1 : [sx1]), ...(Array.isArray(sx2) ? sx2 : [sx2])];
    }
    else {
        return sx1;
    }
}
